module.exports = __webpack_public_path__ + "img/t_lotto.267d5a7.webp";